import React, { useEffect, useState } from "react";
import Button from "../../components/common/ui/Button.jsx";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs/index.js";
import { useDispatch, useSelector } from "react-redux";
import { masterActions } from "../../_store/master.slice.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import Table from "../../components/common/table/Table.jsx";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import activeIcon from "../../assets/svg/active-user.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import deactivateIcon from "../../assets/svg/deactiveate-user.svg";
import pendingIcon from "../../assets/svg/pending-user.svg";
import emailPendingIcon from "../../assets/svg/email-verification.svg";
import inactive_deactivateIcon from "../../assets/svg/inactive-deactivate.svg";
import { history as historynav } from "../../_helpers/index.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import formatPhoneNumber from "../../_helpers/formatPhoneNumber.js";
import { registeredUserActions } from "../../_store/registeredUser.slice.js";
import {
  fDate,
  getCurrentDate,
  MinDate,
  minDate,
  Today,
} from "../../utils/formatTime.js";

const RegisteredUsers = () => {
  const {
    stateDrpList: stateDrplist, // Renaming stateDrpList to stateDrplist
  } = useSelector((x) => x.master);

  const {
    RegisteredPublicUserList: griddata,
    RegisteredUsersFullList: exceldata,
    loading,
    registeredUser,
    initialPublicUser,
  } = useSelector((x) => x.registeredUser);
  //DropdownValues
  const { connectionOptions, statusOptions } = useSelector(
    (x) => x.dropdownOptions
  );
  const [isLoading, setisLoading] = React.useState(false);
  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const dispatch = useDispatch();
  const [showSearchFields, setShowSearchFields] = useState(false);

  // Get States

  useEffect(() => {
    dispatch(masterActions.GetStateList());
    // dispatch(registeredUserActions.clearRegisteredPublicUserList());
  }, [dispatch]);

  useEffect(() => {
    if (
      registeredUser?.UserName ||
      registeredUser?.LastName ||
      registeredUser?.FirstName ||
      registeredUser?.Email ||
      registeredUser?.StateID ||
      registeredUser?.City ||
      registeredUser?.PhoneNumber ||
      registeredUser?.FromDate ||
      registeredUser?.ToDate ||
      registeredUser?.ConnectionStatus !== "2" ||
      registeredUser?.ActiveStatus !== "4"
    ) {
      setisLoading(true);
      dispatch(registeredUserActions.LoadRegisteredPublicUserList(registeredUser))
        .then((result) => {
          setisLoading(false);
          // if (result?.payload?.DataList?.length === 0) {
          //   const searchParams = { ...registeredUser };
          //   searchParams.PageNo = 1;
          //   searchParams.RowCountPerPage = 10;
          //   dispatch(registeredUserActions.setRegisteredUser(searchParams));
          //   dispatch(
          //     registeredUserActions.LoadRegisteredPublicUserList(searchParams)
          //   );
          // }
        })
        .catch((err) => {
          showToastNotification("Failed to load data", "error");
        });
    }
  }, [
    isPageReloading,
  ]);


  const columns = [
    {
      width: "130px",
      key: "UserName",
      name: "Username",
      selector: (row) => row.UserName,
      sortable: true,
      cell: (row) => (
        <div
          className="Common_Link_Style "
          onClick={() => handleUserClick(row)}
        >
          {row.UserName}
        </div>
      ),
    },
    {
      width: "130px",
      key: "LastName",
      name: "Last Name",
      selector: (row) => row.LastName,
      sortable: true,
    },
    {
      width: "130px",
      key: "FirstName",
      name: "First Name",
      selector: (row) => row.FirstName,
      sortable: true,
    },
    {
      width: "290px",
      key: "Email",
      name: "E-mail",
      selector: (row) => row.Email,
      sortable: true,
    },
    {
      width: "150px",
      key: "CellPhone",
      name: "Phone Number",
      selector: (row) => row.CellPhone || "N/A",
      sortable: true,
    }, // Assuming there's a CellPhone field, or fallback to N/A
    {
      width: "120px",
      key: "City",
      name: "City",
      selector: (row) => row.City || "N/A",
      sortable: true,
    }, // Assuming City is present
    {
      width: "100px",
      key: "StateName",
      name: "State",
      selector: (row) => row.StateName || "N/A",
      sortable: true,
    }, // Assuming StateName is present
    {
      width: "100px",
      key: "ConnectionAccept",
      name: "Connection Count",
      selector: (row) => row.ConnectionAccept,
      sortable: true,
    }, // Assuming ConnectionStatus is present

    {
      width: "80px",
      key: "ActiveStatusText",
      name: "Status",
      selector: (row) => row.ActiveStatus,
      cell: (row) => (
        <div className="d-flex flex-wrap h-100">
          <img
            title={
              row.Status === 1
                ? "Activation Pending"
                : row.Status === 2
                  ? "Active"
                  : row.Status === 3
                    ? "Inactive"
                    : row.Status === 4
                      ? "Inactive and Deactivated"
                      : row.Status === 5
                        ? "Deactivated"
                        : row.Status === 6
                          ? "E-mail Reverification Pending"
                          : ""
            }
            alt="alt_image"
            src={
              row.Status === 1
                ? pendingIcon
                : row.Status === 2
                  ? activeIcon
                  : row.Status === 3
                    ? inactiveIcon
                    : row.Status === 4
                      ? inactive_deactivateIcon
                      : row.Status === 5
                        ? deactivateIcon
                        : row.Status === 6
                          ? emailPendingIcon
                          : inactiveIcon
            }
            style={{ width: "24px", height: "24px" }} // Adjust icon size as needed
          // deactivateIcon pendingIcon emailPendingIcon
          // emailPendingIcon inactive_deactivateIcon
          />
        </div>
      ),
      sortable: true,
      // center: true,
    },
  ];

  // Get the Public User Info
  const handleUserClick = async (row) => {
    historynav.navigate("/Admin/RegisteredUserList/Edit", {
      state: {
        userId: row?.PublicUserID,
        ActiveStatus: registeredUser?.ActiveStatus,
      },
    });
    // dispatch(registeredUserActions.GetPublicUserInfo(row.PublicUserID));
  };

  let updatedParam = { ...registeredUser };
  // OnChange Func
  const handleChange = (e) => {
    let { name, value } = e?.target;
    const input = e.target;
    const originalCursor = input.selectionStart;
    const originalValue = value;
    // Remove special characters
    if (name !== "Email") value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (name === "PhoneNumber") {
      // value = formatPhoneNumber(value);
      const onlyDigits = value.replace(/\D/g, "");
      value = formatPhoneNumber(onlyDigits);
    }

    updatedParam = {
      ...registeredUser,
      [name]: name == "City" ? value : value.trim(),
    };
    dispatch(registeredUserActions.setRegisteredUser(updatedParam));

    // setRegisteredUser({ ...registeredUser, [name]: value.trim() });
    if (name === "PhoneNumber") {
      requestAnimationFrame(() => {
        const inputEl = document.querySelector(`input[name="${name}"]`);
        if (inputEl) {
          const newCursor = calculateNewCursorPosition(
            originalCursor,
            originalValue,
            value
          );
          inputEl.setSelectionRange(newCursor, newCursor);
        }
      });
    }
  };

  const calculateNewCursorPosition = (oldPos, oldValue, newValue) => {
    let digitsBeforeCursor = oldValue
      .slice(0, oldPos)
      .replace(/\D/g, "").length;
    let newCursor = 0;
    let digitCount = 0;

    while (newCursor < newValue.length) {
      if (/\d/.test(newValue[newCursor])) {
        digitCount++;
      }
      if (digitCount === digitsBeforeCursor) {
        newCursor++;
        break;
      }
      newCursor++;
    }

    return newCursor;
  };

  const handleDateChange = (value, fieldName) => {
    const date = fDate(value); // Format the date
    let updatedParam = { ...registeredUser, [fieldName]: date };

    // if (
    //   fieldName === "FromDate" &&
    //   new Date(date) > new Date(registeredUser?.ToDate)
    // ) {
    //   updatedParam.ToDate = ""; // Reset ToDate if FromDate is greater
    // }
    dispatch(registeredUserActions.setRegisteredUser(updatedParam));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "FromDate") {
      if (
        registeredUser.ToDate &&
        new Date(value) > new Date(registeredUser.ToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "ToDate") {
      if (
        registeredUser.FromDate &&
        new Date(value) < new Date(registeredUser.FromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }
    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...registeredUser,
      FromDate:
        fieldName === "FromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : registeredUser.FromDate, // preserve existing value
      ToDate:
        fieldName === "ToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : registeredUser.ToDate, // preserve existing value
    };

    dispatch(registeredUserActions.setRegisteredUser(updatedParam));
  };

  let InputParams = {};

  const handleSelectChange = (selectedOption, fieldName) => {
    const selectedValue = selectedOption?.value ?? ""; // Fallback to empty string if no selection
    // Build InputParams with the updated state
    InputParams = {
      ...registeredUser,
      PageNo: 1,
      RowCountPerPage: 10,
      StateID:
        fieldName === "StateID"
          ? selectedValue === ""
            ? 0
            : selectedValue
          : registeredUser?.StateID,
      ConnectionStatus:
        fieldName === "ConnectionStatus"
          ? selectedValue === ""
            ? "2"
            : selectedValue
          : registeredUser?.ConnectionStatus,
      ActiveStatus:
        fieldName === "ActiveStatus"
          ? selectedValue === ""
            ? "4"
            : selectedValue
          : registeredUser?.ActiveStatus,
    };

    dispatch(registeredUserActions.setRegisteredUser(InputParams));

    // Dispatch action with the updated InputParams
    if (
      InputParams?.StateID ||
      InputParams?.ConnectionStatus ||
      // InputParams?.ConnectionStatus !== "2" ||
      InputParams?.ActiveStatus
      // InputParams?.ActiveStatus !== "4"
    ) {
      const {
        PageNo: _,
        RowCountPerPage: __,
        sortBy: ___,
        ...cleanedInputParams
      } = InputParams;
      const {
        PageNo: __1,
        RowCountPerPage: __2,
        sortBy: __3,
        ...cleanedInitialPublicUser
      } = initialPublicUser;

      const isSame =
        JSON.stringify(cleanedInputParams) ===
        JSON.stringify(cleanedInitialPublicUser);
      if (isSame) {
        dispatch(registeredUserActions.clearRegisteredPublicUserList());
      } else {
        setisLoading(true);
        dispatch(registeredUserActions.LoadRegisteredPublicUserList(InputParams)).then((x) => {
          setisLoading(false);
        })
      }
    } else if (
      InputParams?.StateID === 0 &&
      InputParams?.ConnectionStatus === "2" &&
      InputParams?.ActiveStatus === "4"
    ) {
      dispatch(registeredUserActions.clearRegisteredPublicUserList());
      if (
        registeredUser?.UserName ||
        registeredUser?.LastName ||
        registeredUser?.FirstName ||
        registeredUser?.Email ||
        registeredUser?.StateID ||
        registeredUser?.City ||
        registeredUser?.PhoneNumber ||
        registeredUser?.FromDate ||
        registeredUser?.ToDate
      ) {
        const params = {
          ...InputParams,
          StateID: InputParams?.StateID == 0 ? null : InputParams?.StateID,
        };
        setisLoading(true);
        dispatch(registeredUserActions.LoadRegisteredPublicUserList(params)).then((x) => { setisLoading(false) })
      }
    }
  };

  // Reset the Serach box
  const handleReset = () => {
    dispatch(registeredUserActions.resetForm());
    dispatch(registeredUserActions.clearRegisteredPublicUserList());
  };

  //Submit Func
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the form from reloading the page

    if (
      registeredUser?.UserName ||
      registeredUser?.LastName ||
      registeredUser?.FirstName ||
      registeredUser?.Email ||
      registeredUser?.StateID ||
      registeredUser?.City ||
      registeredUser?.PhoneNumber ||
      registeredUser?.FromDate ||
      registeredUser?.ToDate ||
      registeredUser?.ConnectionStatus !== "2" ||
      registeredUser?.ActiveStatus !== "4"
    ) {
      const updateTotalRows = {
        ...registeredUser,
        PageNo: 1,
        RowCountPerPage: 10,
      };

      dispatch(registeredUserActions.setRegisteredUser(updateTotalRows));
      setisLoading(true);
      dispatch(registeredUserActions.LoadRegisteredPublicUserList(updateTotalRows)).then((x) => { setisLoading(false) })
    } else {
      showToastNotification(
        "Please fill any one of the filters to search the details",
        "error"
      );
      dispatch(registeredUserActions.clearRegisteredPublicUserList());
      return; // Exit early to avoid dispatching the action
    }
  };

  const handleRowPerPage = (value) => {
    const updateTotalRows = {
      ...registeredUser,
      PageNo: 1,
      RowCountPerPage: value,
      // exportExcel: true, // Flag to indicate Excel export
    };
    dispatch(registeredUserActions.LoadRegisteredPublicUserList({ ...registeredUser, PageNo: 1, RowCountPerPage: value, }));
    // Dispatch action to load the full list for Excel export
    dispatch(registeredUserActions.setRegisteredUser(updateTotalRows));
  };

  //For Excel and PDF

  const handleClickExcel = () => {
    // Define the title and column headers for the Excel file

    const updateTotalRows = {
      ...registeredUser,
      PageNo: 1,
      RowCountPerPage: griddata?.TotalRecordCount,
      exportExcel: true, // Flag to indicate Excel export
      IsDownloadExcel: true,
    };

    // Dispatch action to load the full list for Excel export

    dispatch(
      registeredUserActions.LoadRegisteredPublicUserList(updateTotalRows)
    );
  };


  const handlePageChangeUser = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }

    // setRegisteredUser((prev) => ({
    //   ...prev,
    //   PageNo: value,
    // }));
    updatedParam = {
      ...registeredUser,
      PageNo: value,
    };
    dispatch(registeredUserActions.LoadRegisteredPublicUserList({ ...registeredUser, PageNo: value }));
    dispatch(registeredUserActions.setRegisteredUser(updatedParam));
  }; // Call API when page changes
  const handleRowsPerPageChangeUser = (value) => {
    updatedParam = {
      ...registeredUser,
      RowCountPerPage: value,
    };

    dispatch(registeredUserActions.setRegisteredUser(updatedParam));
  };

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...registeredUser };

    const newSortOrder = search.sortBy.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    dispatch(registeredUserActions.setRegisteredUser(search));
    dispatch(
      registeredUserActions.LoadRegisteredPublicUserList({
        ...registeredUser,
        sortBy:
          `${column.key} ${newSortOrder}` == "UserName ASC"
            ? "UserName"
            : `${column.key} ${newSortOrder}`,
      })
    );
  };

  const isEmptySearch = !registeredUser?.UserName && !registeredUser?.LastName && !registeredUser?.FirstName && !registeredUser?.Email && !registeredUser?.StateID & !registeredUser?.City && !registeredUser?.PhoneNumber && !registeredUser?.FromDate && !registeredUser?.ToDate &&
    registeredUser?.ConnectionStatus === "2" && registeredUser?.ActiveStatus === "4"

  if (!isEmptySearch && loading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handleSubmit}>
        {/* First Row: Username, Last Name, First Name */}
        <div className="row mb-3">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="UserName"
                id="UserName"
                label="Username"
                value={registeredUser?.UserName}
                handleChange={handleChange}
                placeholder="Username"
                required={false}
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="LastName"
                id="LastName"
                label="Last Name"
                value={registeredUser?.LastName}
                handleChange={handleChange}
                placeholder="Last Name"
                required={false}
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="FirstName"
                id="FirstName"
                label="First Name"
                value={registeredUser?.FirstName}
                handleChange={handleChange}
                placeholder="First Name"
                required={false}
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          {/* Second Row: Email, State, City */}

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="Email"
                id="Email"
                label="E-mail"
                value={registeredUser?.Email}
                handleChange={handleChange}
                placeholder="E-mail"
                required={false}
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* State */}
              <SelectInput
                options={stateDrplist}
                value={registeredUser?.StateID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "StateID")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={registeredUser?.StateID !== 0}
                placeholder="Select State"
                label="State"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="City"
                id="City"
                label="City"
                value={registeredUser?.City}
                handleChange={handleChange}
                placeholder="City"
                required={false}
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          {/* Third Row: Phone Number, From Date, To Date */}

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="PhoneNumber"
                id="PhoneNumber"
                label="Phone Number"
                value={registeredUser?.PhoneNumber}
                handleChange={handleChange}
                placeholder="Phone Number"
                required={false}
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                value={registeredUser?.FromDate}
                handleChange={(e) => handleDateChange(e, "FromDate")}
                name="FromDate"
                label={"From Date"}
                maxDate={
                  registeredUser?.ToDate
                    ? registeredUser?.ToDate
                    : getCurrentDate()
                }
                required={false}
                disabled={false}
                yearDropDown={false}
                monthDropDown={false}
                className={false ? "disabled-date-input" : ""} // Add class conditionally
                isClearable={registeredUser?.FromDate}
                preventClear={!registeredUser?.FromDate}
                minDate={new Date(2017, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "FromDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "FromDate")}
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                value={registeredUser?.ToDate}
                handleChange={(e) => handleDateChange(e, "ToDate")}
                name="ToDate"
                minDate={
                  registeredUser?.FromDate
                    ? registeredUser.FromDate
                    : new Date(2017, 0, 1)
                }
                label={"To Date"}
                maxDate={new Date()}
                required={false}
                disabled={false}
                yearDropDown={false}
                monthDropDown={false}
                className={
                  !registeredUser?.FromDate ? "disabled-date-input" : ""
                } // Conditional class for styling
                isClearable={registeredUser?.ToDate}
                preventClear={!registeredUser?.ToDate}
                handleBlur={(e) => handleDateBlur(e, "ToDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "ToDate")}
              />
            </div>
          </div>

          {/* Fourth Row: Connection, Status */}

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Connection */}
              <SelectInput
                options={connectionOptions}
                value={registeredUser?.ConnectionStatus} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "ConnectionStatus")
                }
                placeholder="Select Connection"
                label="Connection"
                isClearable={registeredUser?.ConnectionStatus !== "2"}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                options={statusOptions}
                value={registeredUser?.ActiveStatus} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "ActiveStatus")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                placeholder="Select Status"
                label={"Status"}
                isClearable={registeredUser?.ActiveStatus !== "4"}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            // variant="danger"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset} // This will now work correctly
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <div className="RegisteredUsers">
      <>
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 ">
            {/* <div className="mb-3">
              <h2 className="form_title_uppercase text-color">
                REGISTERED PUBLIC USER SEARCH
              </h2>
            </div> */}
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  REGISTERED PUBLIC USER SEARCH
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">
                REGISTERED PUBLIC USER SEARCH
              </h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
          </div>
          <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 ">
              <h2 className="form_title_uppercase text-color">
                Registered Users List
              </h2>
              {!isEmptySearch && griddata?.DataList?.length > 0 && (
                <ExcelExport
                  className={"flex-shrink-0"}
                  handleExcelExport={handleClickExcel}
                />
              )}
            </div>
            <Table
              // title={"Registered Users"}
              columns={columns}
              data={isEmptySearch ? [] : griddata?.DataList}
              onChangeRowsPerPage={handleRowPerPage}
              pagination={true}
              NoRecordsText={isEmptySearch ? "Please fill any one of the filters to search the details"
                : "No Records Found"
              }
              onChangePage={(e) => handlePageChangeUser(e)} // Call API when page changes
              totalRowCount={griddata?.TotalRecordCount}
              currentPage={registeredUser?.PageNo}
              paginationPerPage={registeredUser?.RowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={registeredUser?.sortBy?.split(" ")[0]}
              sortDirection={registeredUser?.sortBy?.split(" ")[1]}
            />
          </div>
        </div>
      </>
    </div>
  );
};

export default React.memo(RegisteredUsers);
